import { Modal, Select, Text, TextInput } from '@sede-enterprise/shell-ds-react-framework';
import React, { useState, useEffect } from 'react'
import { updateRating } from '../../../api/sensorApi';
import { toast } from 'react-toastify';
import { useMsal } from '@azure/msal-react';
import { InteractionStatus } from "@azure/msal-browser";


const ratingOptions = [{
    label: "GOOD",
    value: "GOOD",
},
{
    label: "FAIR",
    value: "FAIR",
},
{
    label: "POOR",
    value: "POOR",
},
]

const UpdateRatingModal = ({ sensorID, openRatingModal, setOpenRatingModal, setCommentLoading, userData, setRatingUpdated }) => {

    const [updatedRating, setUpdatedRating] = useState();
    const [updatedComments, setUpdatedComments] = useState('');
    const { instance, inProgress } = useMsal();
    const [userMail, setUserMail] = useState("")
    const activeAccount = inProgress === InteractionStatus.None ? instance.getActiveAccount() : null;
    useEffect(() => {
        if (activeAccount) {
            setUserMail(activeAccount.username.toLowerCase())
        } else {
            setUserMail(null);
        }
    }, [activeAccount]);

    const handleRatingModalClose = () => {
        setUpdatedRating();
        setUpdatedComments('');
        setOpenRatingModal(false);
    }

    const submitUpdatedRating = () => {
        setCommentLoading(true);
        var commentsWithAuthor = `${updatedComments} - Updated by ${userMail}`
        updateRating(sensorID, updatedRating, commentsWithAuthor).then((result) => {
            toast.success(result)
            setRatingUpdated(prev => !prev);
        }).catch((error) => {
            console.log(error)
            toast.error("Error updating sensor rating")
        }).finally(() => {
            setCommentLoading(false);
        });
        handleRatingModalClose();
    }

    return (
        <Modal open={openRatingModal} onClose={handleRatingModalClose} title="Update Ratings"
            actions={[
                {
                    label: 'Submit',
                    action: () => {
                        submitUpdatedRating();
                    },
                    props: {
                        disabled: !updatedRating || !updatedComments
                    }
                },
                {
                    label: 'Cancel',
                    action: () => {
                        handleRatingModalClose();
                    },
                    props: {
                        variant: 'outlined'
                    }
                }

            ]}
        >
            <div className='update-rating-modal'>
                <Select placeholder="Select Rating" label="Rating" options={ratingOptions} value={updatedRating} onChange={(_, option) => {
                    setUpdatedRating(option?.value);
                }} />
                <TextInput placeholder='Add Comments' value={updatedComments} onChange={(e) => setUpdatedComments(e.target.value)} />
                <Text>Author: {userMail}</Text>
            </div>
        </Modal>
    )
}

export default UpdateRatingModal